import api from "../index";

export const GetAllTutorialsApi = (params) => api.get(`Tutorial/Get-All-Tutorial?${params}`);